const calculatorData = [
    {
        id: 1,
        title: "نوع استخوان بندی",
        img: "/images/skeleton.png",
        link: "/skeleton"
    },
    {
        id: 2,
        title: "نسبت کمر به باسن",
        img: "/images/ratio.png",
        link: "/waistToHip"
    },
    {
        id: 3,
        title: "شاخص توده بدنی",
        img: "/images/bodyMass.png",
        link: "/bmi"
    },
    {
        id: 4,
        title: "متابولیسم",
        img: "/images/flame.svg",
        link: "/metabolism"
    }
]

export default calculatorData